import React from 'react';
import { Column, EditType } from '@src/model/table';
import {IP} from '@src/dtos/version.dto';
import { ActionType, getCustomEnumOptions, IPDirection } from '@src/utils/enums';
import {
    createDescriptionColumn,
    createIPAddressColumn, createIPTypeColumn
} from '@src/components/shared/table/column-factories';
import { useStores } from '@src/components/store';
import CustomIcon, {IconType} from '@src/components/shared/custom-icon/custom-icon';

export const useIpListColumns = ():Column<IP>[] => {
    const {customerStore} = useStores();

    return [
        {
            accessor: 'actionType',
            header: 'Action',
            width: '120px',
            displayOnEdit: true,
            type: EditType.Dropdown,
            options: () => getCustomEnumOptions(ActionType),
            getDisplayElement: (column, row) => (
                <div className={'action-cell-content'}>
                    <CustomIcon className={row.actionType.toLowerCase()} type={row.actionType === ActionType.ALLOW ? IconType.ALLOW_ICON : IconType.BLOCK_ICON}/>
                    { row.actionType }
                </div>
            ),
            mandatory: true
        },
        {
            accessor: 'direction',
            header: 'Direction',
            width: '300px',
            getDisplayElement: (column, row) =>
                <div className={`arrow ${row.direction.toLowerCase().replaceAll(' ', '-')}`}>{row.direction}</div>,
            displayOnEdit: true,
            type: EditType.Dropdown,
            options: () => getCustomEnumOptions(IPDirection),
            isKeyField: true,
            mandatory: true
        },
        {
            ...createIPTypeColumn(),
            isKeyField: true,
            isHidden: true
        },
        createIPAddressColumn(customerStore),
        createDescriptionColumn(500)
    ] as Column<IP>[];
};
